import styled from 'styled-components';

export const SaveButtonWrapper = styled.div`
  button {
    width: 140px;
  }
`;

export const DeleteButtonWrapper = styled.div`
  button {
    border: none !important;
    background-color: ${({ theme }) => theme.themeColors.error} !important;
    color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;

    &:hover {
      background-color: ${({ theme }) => theme.themeColors.error} !important;
      color: ${({ theme }) => theme.themeColors.componentNoOpacity} !important;
      opacity: 0.8;
    }

    width: 140px;
  }
`;

export const InputField = styled.input`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
`;

export const TextareaField = styled.textarea`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
`;

export const InputFieldWrapper = styled.div`
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AddCellFormWrapper = styled.div`
  margin: 24px 0;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 6px;
  padding: 16px;
`;

export const AddCellInputRowWrapper = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 8px;
  padding: 16px 0 0 0;
  align-items: center;
`;

export const CellInputFieldWrapper = styled.div`
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CellWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
`;
